import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchContent, fetchServices, fetchPricing, fetchWorks } from '../services/api';

const SiteContext = createContext(null);

export const useSite = () => useContext(SiteContext);

export const SiteProvider = ({ children }) => {
  const [data, setData] = useState({
    content: null,
    services: [],
    pricing: [],
    works: [],
    loading: true,
    error: null,
  });

  const load = async () => {
    try {
      const [content, services, pricing, works] = await Promise.all([
        fetchContent(),
        fetchServices(),
        fetchPricing(),
        fetchWorks(),
      ]);
      setData({ content, services, pricing, works, loading: false, error: null });
    } catch (e) {
      console.error('Site load error', e);
      setData((d) => ({ ...d, loading: false, error: e.message }));
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <SiteContext.Provider value={{ ...data, reload: load }}>
      {children}
    </SiteContext.Provider>
  );
};
